import React from 'react';

const ReadNews = () => {
  return (
    <div className="min-h-screen bg-black text-white flex justify-center items-center">
      <h1 className="text-4xl font-bold">Welcome to the News Page</h1>
    </div>
  );
};

export default ReadNews;
